import config from "../../config/config";
import { apiCall } from "../apiCall";

/**
 * Frontend service for the assessment flow on riu_admin. Calls /api/v1/assessment
 * on riu_backend directly with X-Viewer-Type: riu so the upstream treats the
 * caller as a template author with full visibility.
 */
const BASE = `${config.API_URL}api/v1/assessment`;

const VIEWER_HEADERS = { "X-Viewer-Type": "riu" };

export const AssessmentService = {
  listAssessments,
  getAssessment,
  createAssessment,
  updateAssessment,
  deleteAssessment,

  listIndustries,
  listKpis,
};

async function listAssessments(params = {}) {
  return apiCall(BASE, VIEWER_HEADERS, params, "GET");
}

async function getAssessment(id) {
  return apiCall(`${BASE}/${id}`, VIEWER_HEADERS, {}, "GET");
}

async function createAssessment(payload) {
  return apiCall(BASE, VIEWER_HEADERS, payload, "POST");
}

async function updateAssessment(id, payload) {
  return apiCall(`${BASE}/${id}`, VIEWER_HEADERS, payload, "PUT");
}

async function deleteAssessment(id) {
  return apiCall(`${BASE}/${id}`, VIEWER_HEADERS, {}, "DELETE");
}

async function listIndustries() {
  return apiCall(
    `${config.API_URL}api/v1/industries`,
    {},
    {},
    "GET"
  );
}

/**
 * Pull the KPI catalog and pass through everything the picker's filters
 * need (cascade tags, kpi_status, dates, moduleName) instead of stripping
 * to `{ id, title }`.
 */
async function listKpis() {
  const res = await apiCall(
    `${config.ADMIN_API_URL}getReportingQuestion`,
    {},
    {},
    "GET"
  );
  const rows = res?.data?.data ?? [];
  const normalised = Array.isArray(rows)
    ? rows.map((r) => ({
        id: r.questionId,
        title: r.title,
        moduleName: r.moduleName ?? null,
        kpi_status: r.kpi_status ?? null,
        kpi_type: r.kpi_type ?? null,
        createdAt: r.createdAt ?? null,
        updatedAt: r.updatedAt ?? null,
        rawTags: r.tags ?? null,
      }))
    : [];
  return { ...res, data: { ...(res?.data || {}), data: normalised } };
}
